import { AxiosInstance } from "axios";
import { CreateUserLogDto } from "../types/user-log.type";

export const UserLogEventService = (axiosInstance: AxiosInstance) => {
  const apiBaseUrl = "api/user-log";

  return {
    create: async (data: CreateUserLogDto) => {
      return await axiosInstance.post(`${apiBaseUrl}`, data).then((result) => result.data);
    },
  };
};
